export default __webpack_public_path__ + "static/twitterChatImg-de0fa886c6a0776cac18679c8c2ddd6d.png";